var _rect, _text, _rect2, _text2, _rect3, _text3, _text4, _text5, _rect4, _text6, _text7, _rect5, _text8, _rect6, _text9, _rect7, _text10, _line, _rect8, _text11, _path, _rect9, _text12, _text13, _path2, _text14, _rect10, _text15, _rect11, _text16, _rect12, _text17, _rect13, _text18, _rect14, _text19, _rect15, _text20, _rect16, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _line2, _text32, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatelessGovernance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 420",
    fontFamily: "'Open Sans', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 420,
    fill: "#0C0C0C"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 30,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.5
  }, "GOVERNANCE UNDER STATELESS TOOL PROTOCOLS")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 55,
    width: 340,
    height: 340,
    rx: 6,
    fill: "none",
    stroke: "#3a3a3a",
    strokeWidth: 1,
    strokeDasharray: "4,3"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 75,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 12,
    fontWeight: 600
  }, "AGENT RUNTIME (Client Side)")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 90,
    width: 300,
    height: 60,
    rx: 4,
    fill: "#1a1f2e",
    stroke: "#4a6fa5",
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 112,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 11,
    fontWeight: 600
  }, "Session State")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 130,
    textAnchor: "middle",
    fill: "#aaaaaa",
    fontSize: 9
  }, "execution graph \xB7 context evolution \xB7 cost accumulator \xB7 instruction hash")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 143,
    textAnchor: "middle",
    fill: "#aaaaaa",
    fontSize: 9
  }, "call count \xB7 delegation depth \xB7 anomaly signals")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 165,
    width: 300,
    height: 70,
    rx: 4,
    fill: "#1a2e1a",
    stroke: "#4fa54f",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 187,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 11,
    fontWeight: 600
  }, "Governance Engine (Tool-Call Boundary)")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 205,
    textAnchor: "middle",
    fill: "#aaaaaa",
    fontSize: 9
  }, "loop detection \xB7 scope enforcement \xB7 cost governance \xB7 drift check")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 215,
    width: 70,
    height: 16,
    rx: 3,
    fill: "#2d4a2d",
    stroke: "#4fa54f",
    strokeWidth: 0.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 227,
    textAnchor: "middle",
    fill: "#4fa54f",
    fontSize: 9,
    fontWeight: 600
  }, "ALLOW")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 215,
    width: 85,
    height: 16,
    rx: 3,
    fill: "#4a4a2d",
    stroke: "#c4a832",
    strokeWidth: 0.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 227,
    textAnchor: "middle",
    fill: "#c4a832",
    fontSize: 9,
    fontWeight: 600
  }, "CONSTRAIN")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 215,
    width: 55,
    height: 16,
    rx: 3,
    fill: "#4a2d2d",
    stroke: "#c44a4a",
    strokeWidth: 0.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 307,
    y: 227,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 9,
    fontWeight: 600
  }, "HALT")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 200,
    y2: 165,
    stroke: "#4a6fa5",
    strokeWidth: 1,
    markerEnd: "url(#arrowBlue)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 255,
    width: 200,
    height: 30,
    rx: 4,
    fill: "#1a1a2e",
    stroke: "#6a6aaa",
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 274,
    textAnchor: "middle",
    fill: "#ffffff",
    fontSize: 10
  }, "Proposed Tool Call")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 255 L200 235",
    stroke: "#6a6aaa",
    strokeWidth: 1,
    markerEnd: "url(#arrowGrey)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 305,
    width: 200,
    height: 30,
    rx: 4,
    fill: "#2e2e1a",
    stroke: "#DCCA87",
    strokeWidth: 1
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 319,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 9,
    fontWeight: 600
  }, "HTTP POST /mcp")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 331,
    textAnchor: "middle",
    fill: "#aaaaaa",
    fontSize: 8
  }, "Mcp-Method: tools/call \xB7 Mcp-Name: search")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 285 L200 305",
    stroke: "#4fa54f",
    strokeWidth: 1.5,
    markerEnd: "url(#arrowGreen)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 298,
    fill: "#4fa54f",
    fontSize: 8,
    fontStyle: "italic"
  }, "if allowed")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 55,
    width: 340,
    height: 340,
    rx: 6,
    fill: "none",
    stroke: "#3a3a3a",
    strokeWidth: 1,
    strokeDasharray: "4,3"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 75,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 12,
    fontWeight: 600
  }, "STATELESS MCP SERVER")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 95,
    width: 130,
    height: 40,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555555",
    strokeWidth: 1
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 118,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 10
  }, "Instance A")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 95,
    width: 130,
    height: 40,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555555",
    strokeWidth: 1
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 118,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 10
  }, "Instance B")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 150,
    width: 130,
    height: 40,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555555",
    strokeWidth: 1
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 525,
    y: 173,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 10
  }, "Instance C")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 150,
    width: 130,
    height: 40,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555555",
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 173,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 10
  }, "Instance N...")), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 210,
    width: 180,
    height: 30,
    rx: 4,
    fill: "#1a1a1a",
    stroke: "#555555",
    strokeWidth: 1
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 229,
    textAnchor: "middle",
    fill: "#888888",
    fontSize: 10
  }, "Round-Robin Load Balancer")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 260,
    width: 290,
    height: 120,
    rx: 4,
    fill: "#2e1a1a",
    stroke: "#6a3a3a",
    strokeWidth: 1
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 605,
    y: 280,
    textAnchor: "middle",
    fill: "#c44a4a",
    fontSize: 10,
    fontWeight: 600
  }, "Server Cannot Know:")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 300,
    fill: "#aa7777",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "&#x2717;")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 300,
    fill: "#aaaaaa",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "Session call count")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 318,
    fill: "#aa7777",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "&#x2717;")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 318,
    fill: "#aaaaaa",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "Whether agent is looping")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 336,
    fill: "#aa7777",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "&#x2717;")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 336,
    fill: "#aaaaaa",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "Context growth between calls")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 354,
    fill: "#aa7777",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "&#x2717;")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 354,
    fill: "#aaaaaa",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "Instruction drift")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 372,
    fill: "#aa7777",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "&#x2717;")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 372,
    fill: "#aaaaaa",
    fontSize: 9,
    dominantBaseline: "middle"
  }, "Cumulative session cost")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 320,
    x2: 430,
    y2: 320,
    stroke: "#DCCA87",
    strokeWidth: 1.5,
    markerEnd: "url(#arrowGold)"
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 412,
    textAnchor: "middle",
    fill: "#DCCA87",
    fontSize: 10,
    fontWeight: 600
  }, "Governance enforcement lives here (left) \u2014 not here (right)")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowBlue",
    markerWidth: 6,
    markerHeight: 6,
    refX: 5,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,3 L0,6 Z",
    fill: "#4a6fa5"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowGreen",
    markerWidth: 6,
    markerHeight: 6,
    refX: 5,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,3 L0,6 Z",
    fill: "#4fa54f"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowGrey",
    markerWidth: 6,
    markerHeight: 6,
    refX: 5,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,3 L0,6 Z",
    fill: "#6a6aaa"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowGold",
    markerWidth: 6,
    markerHeight: 6,
    refX: 5,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,3 L0,6 Z",
    fill: "#DCCA87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatelessGovernance);
export default __webpack_public_path__ + "static/media/stateless-governance.1d8a6260703f51c3a84144771240b341.svg";
export { ForwardRef as ReactComponent };